import Vue from 'vue'
import axios from 'axios'

let errorAuthCounter = 0

const initialise = function(ctx) {
  ctx.$axiosMarlon.interceptors.request.use(async (config) => {
    // By default we will make calls to the customer-pwa endpoint
    // For some standalone applications we can choose to change it eg. e-Care
    config.baseURL = `${config.baseURL}${
      window._ecareChannel ? '' : 'customer-pwa/'
    }`

    // e-Care only
    if (window._ecareChannel) {
      config.headers.Authorization =
        ctx.store.state.postal?.platform?.authorization
      config.headers.common['X-Accept-Version'] =
        ctx.store.state.postal?.platform?.apiVersion
      config.headers.common['Access-Control-Allow-Origin'] = '*'
    }

    if (!['auth'].includes(config.url)) {
      const token = await ctx.store.dispatch('getMarlonToken')
      if (token) {
        config.headers.common['X-AUTH-TOKEN'] = token
      }
    }

    if (
      process.env.NODE_ENV !== 'production' ||
      process.env.envName === 'feature'
    )
      console.log('🚀 Making request to ' + config.baseURL + config.url)

    return config
  })

  ctx.$axiosMarlon.interceptors.response.use(
    function(resp) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      ctx.store.dispatch('components/handleNetworkError', false)
      errorAuthCounter = 0
      return resp?.data
    },
    async function(err) {
      ctx.$sentry.setExtra('error', err)
      if (err?.response?.data) {
        ctx.$sentry.setExtra('errorData', err?.response?.data)
      }
      if (err?.response?.status && [500].includes(err?.response?.status)) {
        ctx.$sentry.setTag('owner', 'marlon')
        ctx.$sentry.captureException(err)
      }

      if ((err && window._pwaChannel) || (err && window._ecareChannel)) {
        if (
          err &&
          err.response &&
          err.response.status &&
          [400].includes(err.response.status) &&
          ['auth'].includes(err.config.url)
        ) {
          errorAuthCounter++
          if (
            ctx.store.state.components.hasAuthenticationError ||
            errorAuthCounter > 1
          ) {
            // console.log('Return to error page inside standalone application only')
            errorAuthCounter = 0
            return ctx.store.dispatch('components/handleNetworkError', true)
          } else {
            ctx.store.commit('components/setHasAuthenticationError', true)
            return false
          }
        }

        if (
          err &&
          err.response &&
          err.response.status &&
          [401].includes(err.response.status)
        ) {
          errorAuthCounter++
          // Authentication call failed
          const token = await ctx.store.dispatch('getMarlonToken')
          if (token && err.config) {
            if (errorAuthCounter <= 1) {
              return ctx.$axiosMarlon.request(err.config)
            }
          }
        }
        // console.log('Return to error page inside standalone application only')
        return ctx.store.dispatch('components/handleNetworkError', true)
      }

      if (!err.response || err?.response?.status === 0) {
        // When error has no response it is a network error
        if (
          ctx.store.state.components.hasNavigation &&
          ctx.store.state.components.networkTries < 2
        ) {
          ctx.store.dispatch('components/handleNetworkError', true)
          return
        } else {
          return ctx.error({ statusCode: -1, message: 'Network error' })
        }
      } else {
        ctx.store.dispatch('components/handleNetworkError', false)
      }

      // log out when the status is Unauthorized or Forbidden
      if (
        err &&
        err.response &&
        err.response.status &&
        [401, 403].includes(err.response.status)
      ) {
        return ctx.$logout()
      }

      // return the error when Marlon returned a specific reason
      if (
        err &&
        err.response &&
        err.response.data &&
        err.response.data.errors &&
        err.response.data.errors.length > 0
      ) {
        return Promise.reject(err)
      }

      if (err?.response?.status === 500) {
        return ctx.error({ statusCode: 500, message: 'Server error' })
      }

      // return the error when the status is Bad request
      return Promise.reject(err)
    }
  )
}

export default function(ctx, inject, envName) {
  const _envName = envName || process.env.envName
  const config = {
    headers: { 'Content-Type': 'application/json' }
  }

  switch (_envName) {
    case 'feature':
      config.headers.Authorization =
        'Basic ' + btoa('aaltra' + ':' + '++32@lord@SAFETY@december@55++')
      config.baseURL = process.env.apiMarlonFeature
      break
    case 'staging':
      config.headers.Authorization =
        'Basic ' + btoa('aaltra' + ':' + '++32@lord@SAFETY@december@55++')
      config.baseURL = process.env.apiMarlonStaging
      break
    case 'master':
      config.headers.Authorization =
        'Basic ' + btoa('aaltra' + ':' + '++32@lord@SAFETY@december@55++')
      config.baseURL = process.env.apiMarlonMaster
      break
    default:
      config.headers.Authorization =
        'Basic ' + btoa('daikin_integration' + ':' + '_!5<b]3K~f/$5sh#')
      config.baseURL = process.env.apiMarlonDevelop
  }

  const isContext = !!(ctx && inject)
  const _ctx = isContext ? ctx : Vue.prototype
  const axiosMarlon = isContext
    ? ctx.$axios.create(config)
    : axios.create(config)
  Vue.prototype.$axiosMarlon = axiosMarlon
  if (isContext) {
    ctx.$axiosMarlon = axiosMarlon
    inject('axiosMarlon', axiosMarlon)
    initialise(_ctx)
  } else {
    initialise(_ctx)
    return axiosMarlon
  }
}
